import React from "react";
import comingimage from "../Assets/Images/coming-soon.webp";

const Comingsoon = () => {
  return (
    <>
      <section className="signin">
        <div className="container">
          <div className="centertext">
            <img src={comingimage} alt="Coming Soon" className="notfoundimg" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Comingsoon;
